/**
 * @description : Format a date into print ready.
 * @param {Object} configService The configuration Service object.
 * @returns {String} The formatted time string.
 */
function timeFilter(configService) {

  return (time) => {

    const timeSplit = time.split(':');
    const suffix = (timeSplit[0] < 12) ?
      configService.messages.summary_line_edw.am : configService.messages.summary_line_edw.pm;
    timeSplit[0] = timeSplit[0] % 12 || 12;
    return `${parseInt(timeSplit[0], 10)}:${timeSplit[1]}${suffix}`;

  };

}

export default timeFilter;



// WEBPACK FOOTER //
// ./src/utils/time.filter.js